import { ComponentChannelCollect } from "../../Components/ClaimPointFromEcom";
export const PageChannelCollect = () => {
    return <ComponentChannelCollect />;
};
